export let debugSettings = {
    isDebug: false,
    apiRoot: '',
};
export function loadDebugSettings() {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
        return;
    }
    const loadedDebugSettings = localStorage.getItem('debugSettings');
    if (loadedDebugSettings) {
        debugSettings = JSON.parse(loadedDebugSettings);
    }
    else {
        localStorage.setItem('debugSettings', JSON.stringify(debugSettings));
    }
}
loadDebugSettings();
